export default __webpack_public_path__ + "static/media/avatar31.89609e30.png";